import { render, staticRenderFns } from "./BackboneStyleAuthorBioPicker.vue?vue&type=template&id=dad8a5be&scoped=true"
import script from "./BackboneStyleAuthorBioPicker.vue?vue&type=script&lang=js"
export * from "./BackboneStyleAuthorBioPicker.vue?vue&type=script&lang=js"
import style0 from "./BackboneStyleAuthorBioPicker.vue?vue&type=style&index=0&id=dad8a5be&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad8a5be",
  null
  
)

export default component.exports